import React, { FC } from 'react';
import { Ville } from '../../entity.types';
import { villebaseH } from './villesChart.utils';

type Props = {
  children: (data: {
    data: Array<number>;
    labels: Array<string>;
    handleClick: (wantToOpenInNewTab: boolean, index: number | null) => void;
    baseH: number;
  }) => React.ReactElement;
  handleClick: (
    wantToOpenInNewTab: boolean,
    ville: Ville | null,
    index: number | null,
  ) => void;
  villes: Array<Ville>;
};

export const EnhanceVilleChart: FC<Props> = ({
  children,
  villes,
  handleClick,
}) => {
  return children({
    data: villes.map((v) => v.count),
    labels: villes.map((v) => v.name),
    handleClick: (wantToOpenInNewTab, index) => {
      handleClick(
        wantToOpenInNewTab,
        index !== null ? villes[index] : null,
        index,
      );
    },
    baseH: villebaseH,
  });
};
